export enum EmbeddedEventEnum {
  clickSubscribe = 'clickSubscribe',
  closeModal = 'closeModal',
}
